function range(from, to, step) {
    if (to === undefined) {
        to = from;
        from = 0;
    }
    if (!step) {
        step = 1;
    }
    const values = [];
    for (let i = from; i < to; i += step) values.push(i);
    return values;

}

module.exports = {
    range
};
